import { z } from 'zod';
import { agreementsNames } from '@repo/shared/types';
import { agreementField } from '@repo/shared/types';

export const loanFormAgreementsSchema = z.object({
  [agreementsNames.enum['representative']]: agreementField,
  [agreementsNames.enum['loanTerms']]: agreementField,
  [agreementsNames.enum['pragmaTerms']]: agreementField,
  [agreementsNames.enum['bikbig']]: agreementField,
  [agreementsNames.enum['professionalContract']]: agreementField,
  [agreementsNames.enum['marketing']]: z.boolean().optional(),
  [agreementsNames.enum['payProDataProcessing']]: agreementField,
  [agreementsNames.enum['pragmaGoDataProcessing']]: agreementField,
});

export type LoanFormAgreementsSchema = z.infer<typeof loanFormAgreementsSchema>;

// Tworzenie nowego schematu z wybranymi właściwościami
export const loanFormAgreementsSendableSchema = loanFormAgreementsSchema.pick({
  [agreementsNames.enum['marketing']]: true,
});
export type LoanFormAgreementsSendableSchema = z.infer<typeof loanFormAgreementsSendableSchema>;
